import BaseClient from '@/app/model/api/response/baseApiClient'

class PasswordReminderApi extends BaseClient {
  public sendEmail (bodyData: {[key: string]: string}) {
    const path = '/v1/reminder/user/password'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new PasswordReminderApi()
